import SparkMD5 from 'spark-md5';

const DEFAULT_CHUNK_SIZE = 2 * 1024 * 1024;

/**
 * 分块计算 Blob / File 的 MD5（小写十六进制），避免大文件一次性读入内存。
 * @param {Blob} blob
 * @param {{ chunkSize?: number }} [options]
 * @returns {Promise<string>}
 */
export async function computeBlobMd5Hex(blob, options = {}) {
  if (!blob || typeof blob.size !== 'number') {
    throw new TypeError('computeBlobMd5Hex expects a Blob or File');
  }
  const chunkSize = options.chunkSize ?? DEFAULT_CHUNK_SIZE;
  const spark = new SparkMD5.ArrayBuffer();
  let start = 0;
  while (start < blob.size) {
    const end = Math.min(start + chunkSize, blob.size);
    const buf = await blob.slice(start, end).arrayBuffer();
    spark.append(buf);
    start = end;
  }
  return spark.end();
}

/** @param {File} file @param {{ chunkSize?: number }} [options] @returns {Promise<string>} */
export const computeFileMd5Hex = (file, options) => computeBlobMd5Hex(file, options);


/**
 * @param {number} bytes
 * @returns {string}
 */
export function formatFileSize(bytes) {
  if (bytes == null || Number.isNaN(bytes)) return '';
  const n = Math.max(0, Number(bytes));
  if (n === 0) return '0 B';
  const k = 1024;
  if (n < k) return `${n} B`;
  if (n < k * k) return `${Math.round(n / k)} KB`;
  if (n < k * k * k) return `${Math.round(n / (k * k))} MB`;
  return `${(n / (k * k * k)).toFixed(1)} GB`;
}


export function resolveAttachmentKind(file) {
  if (!file) return '';
  const lower = file.name.toLowerCase();
  const mime = (file.type || '').toLowerCase();
  const isImage = mime.startsWith('image/') || resolveFileTypeByName(file.name) === 'image';

  if (resolveFileTypeByName(file.name) === 'pdf') return 'pdf';
  if (isImage) return 'image';
  return '';
}

export function resolveFileTypeByName(name) {
  if (!name) return '';
  const lower = name.toLowerCase();
  if (lower.endsWith('.pdf')) return 'pdf';
  if (lower.endsWith('.png') || lower.endsWith('.jpg') || lower.endsWith('.jpeg')) return 'image';
  return '';
}
